var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vvc-menu-bar"},_vm._l((_vm.menus),function(menu){return _c('menu-item',{attrs:{"useRouter":_vm.config.useRouter,"activeMenu":_vm.activeMenu,"menu":menu},on:{"menuItem_activate":_vm.emitActivate}},[_c('span',{staticClass:"menu-icon"})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10298a94","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tofu-menu/src/menu.vue
// module id = null
// module chunks = 